import request from '@/utils/request'
import URL from './urlTranslator'

// 高级查询
export function advancedQuery(data) {
  return request({
    url: URL.mdm.guarantee.advancedQuery,
    method: 'post',
    data
  })
}

// 获取保函详情
export function getGuaranteeDetail(data) {
  return request({
    url: URL.mdm.guarantee.detail,
    method: 'post',
    data
  })
}

// 保存保函
export function addGuarantee(data) {
  return request({
    url: URL.mdm.guarantee.add,
    method: 'post',
    data
  })
}

// 修改保函
export function updateGuarantee(data) {
  return request({
    url: URL.mdm.guarantee.update,
    method: 'post',
    data
  })
}

// 批量删除保函状态
export function batchDeleteGuarantee(data) {
  return request({
    url: URL.mdm.guarantee.batchDelete,
    method: 'post',
    data
  })
}

// 批量修改保函状态
export function batchUpdateState(data, param) {
  return request({
    url: URL.mdm.guarantee.batchUpdateState,
    method: 'post',
    params: param,
    data
  })
}
